import { render, staticRenderFns } from "./checkOn.vue?vue&type=template&id=32a477ae&"
import script from "./checkOn.vue?vue&type=script&lang=ts&"
export * from "./checkOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports